// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/stock-img/email_bg_img.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/stock-img/cloud_animation_bg_img.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-section {
  min-height: 36.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0;
  margin: 0 auto;
  position: relative;
}
.email-section::before {
  content: "";
  width: calc(100% + 4.75rem);
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.email-section .email-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  z-index: 1;
  margin: 0 auto;
  position: relative;
}
.email-section .email-wrap .email-box {
  width: 100%;
  max-width: 81.375rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1.25rem;
  margin: 1rem auto 0;
  position: relative;
}
.email-section .email-wrap .email-box .btn-box {
  margin: 0 auto;
}
.email-section .email-wrap .email-box .btn-box .email-btn {
  width: 100%;
  max-width: 35.688rem;
  aspect-ratio: 571/119;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: 200ms all ease-in-out;
}
.email-section .email-wrap .email-box .btn-box .email-btn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.email-section .email-wrap .email-box .btn-box .email-btn:hover:not(:disabled) {
  transform: scale(0.95);
}
.email-section .email-wrap .email-box .btn-box .email-btn:active:not(:disabled) {
  transform: scale(0.85);
}
.email-section .email-wrap .email-box .btn-box .email-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.email-section .email-wrap .email-box .brand-logo-box {
  width: 100%;
  max-width: 15rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1rem;
}
.email-section .email-wrap .email-box .know-more-btn {
  color: var(--white-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4;
  text-transform: capitalize;
  text-decoration: underline;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  margin-bottom: 1rem;
  transition: 200ms all ease-in-out;
}
.email-section .email-wrap .email-box .know-more-btn:hover {
  color: var(--primaryMain-1000);
}
.email-section .email-wrap .animation-wrap {
  width: 100%;
  max-width: 81.375rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1.25rem;
  margin: 0 auto;
  position: absolute;
  top: -100%;
  left: 50%;
  transform: translate(-50%, 0);
}
.email-section .email-wrap .animation-wrap .animation-box {
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 18.125rem;
  background-position: center top;
  aspect-ratio: 3/1;
}
.email-section .email-wrap .animation-wrap .animation-box.animation-box-left {
  max-width: 21.25rem;
}
.email-section .email-wrap .animation-wrap .animation-box.animation-box-left .lottie-animation-box {
  transform: scale(1.4) translate(-3rem, 1rem);
}
.email-section .email-wrap .animation-wrap .animation-box.animation-box-right {
  max-width: 18.125rem;
}
.email-section .email-wrap .animation-wrap .animation-box.animation-box-right .lottie-animation-box {
  transform: scaleX(-1.2) scaleY(1.2) translate(0, 2rem);
}
@media screen and (max-width: 991.98px) {
  .email-section {
    min-height: unset;
    padding: 2.5rem 0;
  }
  .email-section::before {
    width: calc(100% + 2.5rem);
  }
  .email-section .email-wrap .email-box {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .email-section .email-wrap .email-box .btn-box {
    margin: 0;
  }
  .email-section .email-wrap .email-box .btn-box .email-btn {
    max-width: 20rem;
  }
  .email-section .email-wrap .email-box .brand-logo-box {
    max-width: 10rem;
    display: none;
  }
  .email-section .email-wrap .email-box .know-more-btn {
    font-size: 1rem;
  }
  .email-section .email-wrap .animation-wrap {
    max-width: calc(100% - 4rem);
    top: -50%;
  }
  .email-section .email-wrap .animation-wrap .animation-box {
    background-size: 12rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left {
    max-width: 15rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left .lottie-animation-box {
    transform: scale(1.4) translate(-3rem, 1rem);
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right {
    max-width: 12rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right .lottie-animation-box {
    transform: scaleX(-1.2) scaleY(1.2) translate(0, 2rem);
  }
}
@media screen and (max-width: 767.98px) {
  .email-section {
    padding: 2rem 0;
  }
  .email-section::before {
    width: calc(100% + 2rem);
  }
  .email-section .email-wrap .email-box .know-more-btn {
    font-size: 0.875rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box {
    background-size: 8rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left {
    max-width: 11rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left .lottie-animation-box {
    transform: scale(1.4) translate(-3rem, 1rem);
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right {
    max-width: 8rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right .lottie-animation-box {
    transform: scaleX(-1.2) scaleY(1.2) translate(0, 2rem);
  }
}
@media screen and (max-width: 475.98px) {
  .email-section {
    padding: 2rem 0;
  }
  .email-section .email-wrap .animation-wrap {
    max-width: calc(100% - 2rem);
  }
  .email-section .email-wrap .animation-wrap .animation-box {
    background-size: 5rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left {
    max-width: 7rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-left .lottie-animation-box {
    transform: scale(1.4) translate(-1rem, 0.5rem);
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right {
    max-width: 5rem;
  }
  .email-section .email-wrap .animation-wrap .animation-box.animation-box-right .lottie-animation-box {
    transform: scaleX(-1.2) scaleY(1.2) translate(0, 0.75rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PageFooter/EmailStyle.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,2BAAA;EACA,YAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACJ;AAEE;EACE,WAAA;EACA,gCAAA;EACA,UAAA;EAEA,cAAA;EACA,kBAAA;AADJ;AAGI;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AADN;AAGM;EACE,cAAA;AADR;AAuCQ;EACE,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;AArCV;AAuCU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AArCZ;AAwCU;EACE,sBAAA;AAtCZ;AAyCU;EACE,sBAAA;AAvCZ;AA0CU;EACE,YAAA;EACA,mBAAA;AAxCZ;AA6CM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AA3CR;AA8CM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AA5CR;AA8CQ;EACE,8BAAA;AA5CV;AAiDI;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;AA/CN;AAiDM;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,+BAAA;EACA,iBAAA;AA/CR;AAiDQ;EACE,mBAAA;AA/CV;AAiDU;EACE,4CAAA;AA/CZ;AAmDQ;EACE,oBAAA;AAjDV;AAmDU;EACE,sDAAA;AAjDZ;AAwDE;EAtLF;IAuLI,iBAAA;IACA,iBAAA;EArDF;EAuDE;IACE,0BAAA;EArDJ;EA2DI;IACE,2BAAA;IACA,mBAAA;IACA,sBAAA;EAzDN;EA2DM;IACE,SAAA;EAzDR;EA2DQ;IACE,gBAAA;EAzDV;EA6DM;IACE,gBAAA;IACA,aAAA;EA3DR;EA8DM;IACE,eAAA;EA5DR;EAgEI;IACE,4BAAA;IACA,SAAA;EA9DN;EAgEM;IACE,sBAAA;EA9DR;EAgEQ;IACE,gBAAA;EA9DV;EAgEU;IACE,4CAAA;EA9DZ;EAkEQ;IACE,gBAAA;EAhEV;EAkEU;IACE,sDAAA;EAhEZ;AACF;AAuEE;EAnPF;IAoPI,eAAA;EApEF;EAsEE;IACE,wBAAA;EApEJ;EAiFM;IACE,mBAAA;EA/ER;EAoFM;IACE,qBAAA;EAlFR;EAoFQ;IACE,gBAAA;EAlFV;EAoFU;IACE,4CAAA;EAlFZ;EAsFQ;IACE,eAAA;EApFV;EAsFU;IACE,sDAAA;EApFZ;AACF;AA2FE;EAjSF;IAkSI,eAAA;EAxFF;EA2FI;IACE,4BAAA;EAzFN;EA2FM;IACE,qBAAA;EAzFR;EA2FQ;IACE,eAAA;EAzFV;EA2FU;IACE,8CAAA;EAzFZ;EA6FQ;IACE,eAAA;EA3FV;EA6FU;IACE,yDAAA;EA3FZ;AACF","sourcesContent":[".email-section {\n  min-height: 36.875rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem 0;\n  margin: 0 auto;\n  position: relative;\n\n  &::before {\n    content: \"\";\n    width: calc(100% + 2.375rem * 2);\n    height: 100%;\n    background-image: url('../../../public/assets/stock-img/email_bg_img.webp');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center top;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .email-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    z-index: 1;\n    // padding: 0 2.375rem;\n    margin: 0 auto;\n    position: relative;\n\n    .email-box {\n      width: 100%;\n      max-width: 81.375rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      gap: 1.25rem;\n      margin: 1rem auto 0;\n      position: relative;\n\n      .btn-box {\n        margin: 0 auto;\n\n        // .email-btn {\n        //   min-height: 4rem;\n        //   background-color: var(--white-1000);\n        //   border: 1px solid var(--black-1000);\n        //   border-radius: 1rem;\n        //   box-shadow: 0px 4px 4px var(--black-250);\n        //   font-family: \"Inter\", sans-serif;\n        //   color: var(--white-1000);\n        //   font-size: 1.5rem;\n        //   font-weight: 700;\n        //   line-height: 1;\n        //   text-transform: lowercase;\n        //   text-decoration: none;\n        //   display: flex;\n        //   justify-content: center;\n        //   align-items: center;\n        //   gap: 0.75rem;\n        //   cursor: pointer;\n        //   padding: 1rem 2.5rem;\n        //   position: relative;\n        //   transition: 200ms all ease-in-out;\n\n        //   &:hover:not(:disabled) {\n        //     transform: scale(0.95);\n        //   }\n        \n        //   &:active:not(:disabled) {\n        //     transform: scale(0.85);\n        //   }\n        \n        //   &:disabled {\n        //     opacity: 0.5;\n        //     cursor: not-allowed;\n        //   }\n        // }\n        \n        .email-btn {\n          width: 100%;\n          max-width: 35.688rem;\n          aspect-ratio: 571/119;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n          position: relative;\n          transition: 200ms all ease-in-out;\n\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            object-position: center;\n          }\n\n          &:hover:not(:disabled) {\n            transform: scale(0.95);\n          }\n        \n          &:active:not(:disabled) {\n            transform: scale(0.85);\n          }\n        \n          &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n          }\n        }\n      }\n\n      .brand-logo-box {\n        width: 100%;\n        max-width: 15rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin-bottom: 1rem;\n      }\n\n      .know-more-btn {\n        color: var(--white-1000);\n        font-size: 1.5rem;\n        font-weight: 700;\n        line-height: 1.4;\n        text-transform: capitalize;\n        text-decoration: underline;\n        text-align: center;\n        white-space: nowrap;\n        cursor: pointer;\n        margin-bottom: 1rem;\n        transition: 200ms all ease-in-out;\n\n        &:hover {\n          color: var(--primaryMain-1000);\n        }\n      }\n    }\n\n    .animation-wrap {\n      width: 100%;\n      max-width: 81.375rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      gap: 1.25rem;\n      margin: 0 auto;\n      position: absolute;\n      top: -100%;\n      left: 50%;\n      transform: translate(-50%, 0);\n\n      .animation-box {\n        width: 100%;\n        background-image: url('../../../public/assets//stock-img/cloud_animation_bg_img.webp');\n        background-repeat: no-repeat;\n        background-size: 18.125rem;\n        background-position: center top;\n        aspect-ratio: 3/1;\n\n        &.animation-box-left {\n          max-width: 21.25rem;\n          \n          .lottie-animation-box {\n            transform: scale(1.4) translate(-3rem, 1rem);\n          }\n        }\n        \n        &.animation-box-right {\n          max-width: 18.125rem;\n\n          .lottie-animation-box {\n            transform: scaleX(-1.2) scaleY(1.2)  translate(0, 2rem);\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    min-height: unset;\n    padding: 2.5rem 0;\n    \n    &::before {\n      width: calc(100% + 1.25rem * 2);\n    }\n  \n    .email-wrap {\n      // padding: 0 1.25rem;\n\n      .email-box {\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: column;\n\n        .btn-box {\n          margin: 0;\n\n          .email-btn {\n            max-width: 20rem;\n          }\n        }\n\n        .brand-logo-box {\n          max-width: 10rem;\n          display: none;\n        }\n        \n        .know-more-btn {\n          font-size: 1rem;\n        }\n      }\n\n      .animation-wrap {\n        max-width: calc(100% - 4rem);\n        top: -50%;\n\n        .animation-box {\n          background-size: 12rem;\n\n          &.animation-box-left {\n            max-width: 15rem;\n            \n            .lottie-animation-box {\n              transform: scale(1.4) translate(-3rem, 1rem);\n            }\n          }\n          \n          &.animation-box-right {\n            max-width: 12rem;\n  \n            .lottie-animation-box {\n              transform: scaleX(-1.2) scaleY(1.2)  translate(0, 2rem);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    \n    &::before {\n      width: calc(100% + 1rem * 2);\n    }\n\n    .email-wrap {\n      // padding: 0 1rem;\n\n      .email-box {\n        .btn-box {\n          .email-btn {\n            \n          }\n        }\n\n        .know-more-btn {\n          font-size: 0.875rem;\n        }\n      }\n\n      .animation-wrap {\n        .animation-box {\n          background-size: 8rem;\n\n          &.animation-box-left {\n            max-width: 11rem;\n            \n            .lottie-animation-box {\n              transform: scale(1.4) translate(-3rem, 1rem);\n            }\n          }\n          \n          &.animation-box-right {\n            max-width: 8rem;\n  \n            .lottie-animation-box {\n              transform: scaleX(-1.2) scaleY(1.2)  translate(0, 2rem);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 475.98px) {\n    padding: 2rem 0;\n\n    .email-wrap {\n      .animation-wrap {\n        max-width: calc(100% - 2rem);\n\n        .animation-box {\n          background-size: 5rem;\n\n          &.animation-box-left {\n            max-width: 7rem;\n            \n            .lottie-animation-box {\n              transform: scale(1.4) translate(-1rem, 0.5rem);\n            }\n          }\n          \n          &.animation-box-right {\n            max-width: 5rem;\n  \n            .lottie-animation-box {\n              transform: scaleX(-1.2) scaleY(1.2)  translate(0, 0.75rem);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
